import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { times } from 'lodash';
import React from 'react';

import './LessonCardSkeleton.scss';
import { LessonCardsGroupedTimePosition } from './LessonCardsGrouped';

export interface LessonCardSkeletonProps {
  position?: LessonCardsGroupedTimePosition;
}

export const LessonCardSkeleton: React.FC<LessonCardSkeletonProps> = props => {
  const { position } = props;

  return (
    <Skeleton
      className={`lessonCardSkeleton position-${
        position === LessonCardsGroupedTimePosition.Top ||
        position === undefined
          ? 'top'
          : 'left'
      }`}
    >
      <div className="dayHeadline">
        {/* Day Headline */}
        <SkeletonItem className="dayHeadlineLine" />
      </div>
      <div className="flex gap-2 outer">
        <div className="time">
          <SkeletonItem className="timeLineTop" />
          <SkeletonItem className="timeLineBottom" />
        </div>
        <div className="flex flex-col teachingUnit flex-1">
          {times(3, index => (
            <div className="lessonCard" key={index}>
              <div className="flex flex-col">
                <div className="inner">
                  <SkeletonItem className="titleLine" />
                  {times(2, innerIndex => (
                    <div
                      key={innerIndex}
                      className="flex items-center gap-2 entryRow"
                    >
                      <SkeletonItem shape="circle" className="avatarShape" />
                      <div className="flex flex-col flex-1">
                        <SkeletonItem
                          className={`entryNameLine entryNameLine-${innerIndex % 2}`}
                        />
                        <SkeletonItem
                          className={`entrySubLine entrySubLine-${innerIndex % 2}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Skeleton>
  );
};
